/* eslint-disable @typescript-eslint/ban-types */
import { SelectProps } from "@material-ui/core";
import { ParsableDate } from "@material-ui/pickers/constants/prop-types";
import { FieldAttributes } from "formik";
import { useTranslation } from "react-i18next";
import {
  SalutationType,
  mapSalutationTypeAsLabel,
} from "../../../models/enums/salutationType.enum";
import CustomSelect from "./CustomSelect";
import { useScrollLockOnSelect } from "../../../hooks/useScrollLock";

/**
 * @interface SalutationSelectProps
 */
interface SalutationSelectProps {
  value?: ParsableDate;
}

/**
 * SalutationSelect
 *
 * A reusable Formik-connected Select component for selecting a salutation.
 * It uses Material-UI and supports internationalized option labels.
 *
 * @param {SalutationSelectProps} props - The props for the component.
 * @param {string} props.value - The selected value.
 *
 * @returns {JSX.Element} The rendered SalutationSelect component.
 */
const SalutationSelect: React.FC<
  SalutationSelectProps & FieldAttributes<{}> & SelectProps
> = ({ ...props }) => {
  const { t } = useTranslation(["common", "snackbars"]);
  const { handleOpen, handleClose } = useScrollLockOnSelect();

  return (
    <CustomSelect
      {...props}
      autoComplete="salutation"
      onOpen={handleOpen}
      onClose={handleClose}
      options={[
        {
          key: "herr",
          value: SalutationType.Male,
          label: mapSalutationTypeAsLabel(SalutationType.Male),
        },
        {
          key: "frau",
          value: SalutationType.Female,
          label: mapSalutationTypeAsLabel(SalutationType.Female),
        },
        {
          key: "none",
          value: SalutationType.Neutral,
          label: mapSalutationTypeAsLabel(SalutationType.Neutral),
        },
      ]}
      id="anrede"
      labelId="anrede"
      label={t("profile.overviewProfile.salutation.title", { ns: "common" })}
      MenuProps={{
        disableAutoFocus: true,
        disableScrollLock: true,
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        MenuListProps: {
          onFocus: (e: React.FocusEvent) => e.preventDefault(),
        },
      }}
    />
  );
};

export default SalutationSelect;
